import { type ClassValue, clsx } from 'clsx'
import { extendTailwindMerge, validators } from 'tailwind-merge'

// tailwind-merge 3 targets Tailwind 4, where bare `outline` is a width. In
// Tailwind 3 it's a style, so outline-2 must not drop it.
const twMerge = extendTailwindMerge({
  override: {
    classGroups: {
      'outline-w': [
        {
          outline: [
            validators.isNumber,
            validators.isArbitraryVariableLength,
            validators.isArbitraryLength,
          ],
        },
      ],
    },
  },
  extend: {
    classGroups: {
      'outline-style': ['outline'],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** Row hover background that persists while a child popover (data-state=open) is open. */
export const INTERACTIVE_ROW_HOVER_BG =
  'hover:bg-surface-hover has-[[data-state=open]]:bg-surface-hover'

/** Desktop-only variant with md: responsive prefix. */
export const INTERACTIVE_ROW_HOVER_BG_MD =
  'md:hover:bg-surface-hover md:has-[[data-state=open]]:bg-surface-hover'
